<template>
  <v-expansion-panels accordion>
    <v-expansion-panel
      v-for="category in categories"
      :key="'cat_' + category.id"
    > 
      <v-expansion-panel-header class="font-weight-medium">
        {{ category.name }}
      </v-expansion-panel-header>

      <v-expansion-panel-content>
        <!-- Рекурсия: если есть подкатегории -->
        <MediaCategoryPanel
          v-if="category.subcategories && category.subcategories.length > 0"
          :categories="category.subcategories"
          @create="handleCreate"
        />

        <!-- Шаблоны текущего уровня -->
        <v-list
          v-if="Array.isArray(category.mediaTemplates) && category.mediaTemplates.length > 0"
        >
          <v-list-item
            v-for="mediaTemplate in category.mediaTemplates"
            :key="'media_' + mediaTemplate.id"
            @click="handleCreate(mediaTemplate.id)"
          >
            <v-list-item-title class="body-2 pl-2">
              {{ mediaTemplate.name }}
            </v-list-item-title>
          </v-list-item>
        </v-list>

        <!-- Если на этом уровне вообще ничего нет -->
        <div
          v-else-if="
            (!category.subcategories || category.subcategories.length === 0) &&
            (!Array.isArray(category.mediaTemplates) || category.mediaTemplates.length === 0)
          "
          class="text-center caption pa-1"
        >
          Не найдено
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  name: 'MediaCategoryPanel',

  props: {
    categories: {
      type: Array,
      required: true,
      default: () => []
    }
  },

  methods: {
    handleCreate(id) {
      this.$emit('create', id)
    }
  }
}
</script>